import { DateTime } from "luxon";
import { create } from "zustand";
import { persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

export const usePersistStore = create()(
  immer(
    persist(
      (set) => ({
        setValue: (key, value) => {
          set(
            (s) => ({
              ...s,
              [key]: value,
            }),
            false,
            `setValue(${key}, ${value})`,
          );
        },

        token: null,

        mfaDeviceTokens: {},

        setMfaDeviceToken: (email, deviceToken) => {
          set(
            (state) => ({
              ...state,
              mfaDeviceTokens: {
                ...state.mfaDeviceTokens,
                [email]: deviceToken,
              },
            }),
            false,
          );
        },

        legacyFeaturesDismissed: {},
        newFeaturesClicked: [],
        savedScriptActivity: {},

        handlePSChangeAll: (data = {}) => {
          set(
            (prev) => ({
              ...prev,
              ...data,
            }),
            false,
          );
        },

        bookmarkedScripts: {},
        addBookmarkedScript: (id) => {
          set(
            (state) => ({
              ...state,
              bookmarkedScripts: {
                ...state.bookmarkedScripts,
                [id]: DateTime.now().toISODate(),
              },
            }),
            false,
          );
        },
        removeBookmarkedScript: (id) => {
          set((state) => {
            delete state.bookmarkedScripts[id];
            return state;
          }, false);
        },

        isOrderedByBookmarks: false,
        setOrderedByBookmarks: () => {
          set((state) => {
            state.isOrderedByBookmarks = true;
            return state;
          }, false);
        },
        unsetOrderedByBookmarks: () => {
          set((state) => {
            state.isOrderedByBookmarks = false;
            return state;
          }, false);
        },
      }),
      {
        name: "VIDLET",
      },
    ),
  ),
);

export default usePersistStore;
